import { render, staticRenderFns } from "./TaishokutodokePreview.vue?vue&type=template&id=14484871"
import script from "./TaishokutodokePreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaishokutodokePreview.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports